import { graphql } from 'gatsby';
import Icon from '@/components/Icon/IconAsset';

import { StyledFooterSocialLink, StyledLinkLabel } from './FooterSocialLink.styles';

const FooterSocialLink = ({
  footerSocialLinkElements: elements,
}: Queries.FOOTER_SOCIAL_LINKFragment) => {
  const { title, target, url, icon } = elements;
  const linkTarget = target?.value;

  return (
    <StyledFooterSocialLink
      href={url.value}
      target={linkTarget}
      rel={linkTarget === '_blank' ? 'noopener noreferrer' : undefined}
    >
      {icon?.value && <Icon {...icon.value} />}
      <StyledLinkLabel>{title?.value}</StyledLinkLabel>
    </StyledFooterSocialLink>
  );
};

export default FooterSocialLink;

export const fragment = graphql`
  fragment FOOTER_SOCIAL_LINK on kontent_item_footer_social_link {
    id
    footerSocialLinkElements: elements {
      title {
        value
      }
      target {
        value
      }
      url {
        value
      }
      icon {
        value {
          url
        }
      }
    }
  }
`;
